module.exports = __webpack_public_path__ + "img/features-tabs-icon-01.0c7d6207.svg";